import {
  __spreadValues
} from "./chunk-6LOWPV43.js";

// src/init.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import BadgePlaceholder from "./assets/badge-placeholder.svg";

// src/components/celebration-confetti-animation/celebration-confetti-animation.tsx
import React, { useEffect } from "react";
import { useLottieAnimation } from "@leagueplatform/lottie";
import { usePrefersReducedMotion } from "@leagueplatform/web-common";
import { Box } from "@leagueplatform/genesis-core";
var animationData = import("./celebration-confetti.lottie-NGQIEGWM.js");
function CelebrationConfettiAnimation({
  animationRef,
  lottieConfig: configOverrides,
  shouldPlay
}) {
  const prefersReducedMotion = usePrefersReducedMotion();
  const lottieConfig = __spreadValues({
    loop: false,
    autoplay: shouldPlay
  }, configOverrides);
  const { animationContainerRef, animation } = useLottieAnimation({
    lottieConfig,
    animationRef,
    animationData
  });
  useEffect(() => {
    if (shouldPlay) {
      animation == null ? void 0 : animation.goToAndPlay(0);
    }
  }, [shouldPlay, animation]);
  return prefersReducedMotion ? null : /* @__PURE__ */ React.createElement(Box, { css: { opacity: shouldPlay ? 1 : 0 }, ref: animationContainerRef });
}

// src/components/celebration-badge-animation/celebration-badge-animation.tsx
import React2, { useEffect as useEffect2 } from "react";
import { useLottieAnimation as useLottieAnimation2 } from "@leagueplatform/lottie";
import { usePrefersReducedMotion as usePrefersReducedMotion2 } from "@leagueplatform/web-common";
import { Box as Box2 } from "@leagueplatform/genesis-core";
var animationData2 = import("./celebration-lines.lottie-VE3Q4JPJ.js");
function CelebrationBadgeAnimation({
  animationRef,
  lottieConfig: configOverrides,
  shouldPlay
}) {
  const prefersReducedMotion = usePrefersReducedMotion2();
  const lottieConfig = __spreadValues({
    loop: false,
    autoplay: false
  }, configOverrides);
  const { animationContainerRef, animation } = useLottieAnimation2({
    lottieConfig,
    animationRef,
    animationData: animationData2
  });
  useEffect2(() => {
    if (shouldPlay) {
      animation == null ? void 0 : animation.goToAndPlay(0);
    }
  }, [shouldPlay, animation]);
  return prefersReducedMotion ? null : /* @__PURE__ */ React2.createElement(Box2, { css: { opacity: shouldPlay ? 1 : 0 }, ref: animationContainerRef });
}

// src/asset-map.ts
var REWARDS_EVENTS_ASSETS = {
  ACHIEVEMENT_BADGE_PLACEHOLDER: BadgePlaceholder,
  ACHIEVEMENT_CONFETTI_ANIMATION: CelebrationConfettiAnimation,
  ACHIEVEMENT_BADGE_ANIMATION: CelebrationBadgeAnimation
};

// src/init.ts
var initModule = () => {
  setDefaultAssets(REWARDS_EVENTS_ASSETS);
};

// src/components/rewards-event-controller/rewards-event-controller.view.tsx
import React11, { useState as useState5, useEffect as useEffect9, useCallback } from "react";

// src/hooks/use-display-reward-event.hook.ts
import { ReconnectingSocketController } from "@leagueplatform/league-socket";
import { useState as useState2, useEffect as useEffect4 } from "react";

// src/hooks/use-window-focus.hook.ts
import { useEffect as useEffect3, useState } from "react";
function useWindowFocus() {
  const [isWindowFocused, setIsWindowFocused] = useState(true);
  function windowFocused() {
    setIsWindowFocused(true);
  }
  function windowUnfocused() {
    setIsWindowFocused(false);
  }
  useEffect3(() => {
    window.addEventListener("focus", windowFocused);
    window.addEventListener("blur", windowUnfocused);
    return () => {
      window.removeEventListener("focus", windowFocused);
      window.removeEventListener("blur", windowUnfocused);
    };
  }, []);
  return { isWindowFocused };
}

// src/hooks/use-display-reward-event.hook.ts
function useDisplayRewardEvent() {
  const [currentRewardEvent, setCurrentRewardEvent] = useState2();
  const [rewardEvents, setRewardEvents] = useState2([]);
  const { isWindowFocused } = useWindowFocus();
  useEffect4(() => {
    const removeEventHandler = ReconnectingSocketController.addEventHandler(
      (newEvent) => {
        setRewardEvents((prev) => {
          if (newEvent.message_type === "user_rewards_updates" && !prev.some((event) => event.message_id === newEvent.message_id)) {
            prev.push(newEvent);
          }
          return [...prev];
        });
      }
    );
    return () => {
      removeEventHandler();
    };
  }, []);
  useEffect4(() => {
    if (isWindowFocused) {
      setCurrentRewardEvent(rewardEvents[0]);
    }
  }, [isWindowFocused, rewardEvents]);
  const rewardEventViewed = () => {
    setRewardEvents((prev) => {
      prev.shift();
      return [...prev];
    });
  };
  return { currentRewardEvent, rewardEventViewed };
}

// src/components/rewards-event-controller/rewards-event-controller.view.tsx
import { EVENT_NAME as EVENT_NAME6, trackAnalyticsEvent as trackAnalyticsEvent6 } from "@leagueplatform/analytics";
import { Box as Box8 } from "@leagueplatform/genesis-core";

// src/components/celebration-modal/celebration-modal.view.tsx
import React4, { useState as useState4, useRef as useRef2, useEffect as useEffect6 } from "react";
import { Carousel } from "@leagueplatform/web-common-components";
import { LinkLegacy as Link } from "@leagueplatform/routing";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";
import { EVENT_NAME, trackAnalyticsEvent } from "@leagueplatform/analytics";
import {
  Box as Box4,
  Button,
  Modal,
  StackLayout as StackLayout2,
  VisuallyHidden
} from "@leagueplatform/genesis-core";

// src/utils/analytics-dict-factory.utils.ts
function AnalyticsDictFactory(array) {
  const dict = {};
  array.forEach((value, index) => {
    dict[`index_${index}`] = value;
  });
  return dict;
}

// src/components/celebration-modal/celebration-modal.view.tsx
import { useIntl as useIntl2 } from "@leagueplatform/locales";

// src/components/celebration-content/celebration-content.view.tsx
import React3, { useRef, useEffect as useEffect5, useState as useState3 } from "react";
import { CoverImage } from "@leagueplatform/genesis-commons";
import {
  Box as Box3,
  HeadingText,
  StackLayout,
  UtilityText,
  keyframes,
  styled
} from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import { usePrefersReducedMotion as usePrefersReducedMotion3 } from "@leagueplatform/web-common";
import { Badge } from "@leagueplatform/web-common-components";
import {
  ChallengeTokenIcon,
  PointsIcon,
  RewardPointsIcon
} from "@leagueplatform/rewards-common";
var CelebrationLinesContainer = styled(Box3, {
  position: "absolute",
  width: "368px",
  height: "368px"
});
var ScaleAnimation = keyframes({
  "0%": {
    transform: "scale(0)",
    opacity: 1
  },
  "75%": {
    transform: "scale(1.1)",
    opacity: 1
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
});
var FadeDownAnimation = keyframes({
  from: {
    transform: `translate(0px, -25px)`,
    opacity: 0
  },
  to: {
    transform: `translate(0px, 0px)`,
    opacity: 1
  }
});
var FadeUpAnimation = keyframes({
  from: {
    transform: `translate(0px, 25px)`,
    opacity: 0
  },
  to: {
    transform: `translate(0px, 0px)`,
    opacity: 1
  }
});
var AnimatedCoverImage = styled(CoverImage, {
  animationTimingFunction: "ease-in",
  animationDuration: "0.4s",
  animationDelay: "0.5s",
  variants: {
    animationKey: {
      reducedMotion: { opacity: 1, animation: "none" },
      ScaleAnimation: { opacity: 0, animationName: `${ScaleAnimation}` }
    },
    isVisible: {
      true: { animationPlayState: "running" },
      false: { animationPlayState: "paused" }
    }
  }
});
var AnimatedTranslateWrapper = styled(Box3, {
  animationTimingFunction: "ease-out",
  textAlign: "center",
  variants: {
    isVisible: {
      true: { animationPlayState: "running" },
      false: { animationPlayState: "paused" }
    },
    animationKey: {
      reducedMotion: { opacity: 1, animation: "none" },
      "animated-header": {
        opacity: 0,
        animation: `${FadeDownAnimation}`,
        animationDuration: "1s",
        animationDelay: "1s"
      },
      "animated-subheader": {
        opacity: 0,
        animation: `${FadeUpAnimation}`,
        animationDuration: "1s",
        animationDelay: "1.3s"
      },
      "animated-points": {
        opacity: 0,
        animation: `${FadeUpAnimation}`,
        animationDuration: "1s",
        animationDelay: "1.7s"
      }
    }
  }
});
var CelebrationContent = ({
  achievement,
  isVisible,
  index
}) => {
  var _a, _b, _c;
  const { formatMessage } = useIntl();
  const celebrationBadgeAnimationRef = useRef(null);
  const [celebrationViewed, setCelebrationViewed] = useState3(false);
  const preferredReducedMotion = usePrefersReducedMotion3();
  const [showAnimation, setShowAnimation] = useState3(false);
  const { unit, value } = (achievement == null ? void 0 : achievement.reward) || {};
  useEffect5(() => {
    if (isVisible && !celebrationViewed) {
      setTimeout(() => {
        setShowAnimation(true);
      }, 1300);
      setCelebrationViewed(true);
    }
  }, [isVisible, celebrationViewed]);
  return /* @__PURE__ */ React3.createElement(
    StackLayout,
    {
      orientation: "vertical",
      horizontalAlignment: "center",
      css: { alignItems: "center", width: "368px" }
    },
    /* @__PURE__ */ React3.createElement(
      AnimatedTranslateWrapper,
      {
        animationKey: preferredReducedMotion ? "reducedMotion" : "animated-header",
        css: { animationFillMode: "forwards" },
        flexDirection: "column",
        isVisible
      },
      /* @__PURE__ */ React3.createElement(
        HeadingText,
        {
          level: "1",
          size: "xxl",
          css: {
            marginTop: "$one",
            marginBottom: "$half",
            textAlign: "center"
          }
        },
        achievement == null ? void 0 : achievement.celebration_title
      ),
      /* @__PURE__ */ React3.createElement(
        UtilityText,
        {
          css: { textAlign: "center", typography: "$bodyTwoSecondary" }
        },
        achievement == null ? void 0 : achievement.celebration_subtitle
      )
    ),
    /* @__PURE__ */ React3.createElement(
      StackLayout,
      {
        css: {
          position: "relative",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "$oneAndHalf",
          marginBottom: "$half",
          "@desktop": {
            marginTop: "$four",
            marginBottom: "$half"
          }
        }
      },
      /* @__PURE__ */ React3.createElement(CelebrationLinesContainer, null, handleStaticAsset(
        "ACHIEVEMENT_BADGE_ANIMATION" /* ACHIEVEMENT_BADGE_ANIMATION */,
        {
          isComponent: true,
          props: {
            key: `animation-${index}`,
            animationRef: celebrationBadgeAnimationRef,
            shouldPlay: showAnimation
          }
        }
      )),
      /* @__PURE__ */ React3.createElement(
        AnimatedCoverImage,
        {
          animationKey: preferredReducedMotion ? "reducedMotion" : "ScaleAnimation",
          isVisible,
          css: { animationFillMode: "forwards" },
          size: "184px",
          backgroundSize: "contain",
          src: (_b = (_a = achievement == null ? void 0 : achievement.image) == null ? void 0 : _a.large) != null ? _b : handleStaticAsset(
            "ACHIEVEMENT_BADGE_PLACEHOLDER" /* ACHIEVEMENT_BADGE_PLACEHOLDER */
          ),
          alt: (_c = achievement == null ? void 0 : achievement.name) != null ? _c : formatMessage({ id: "YOUVE_EARNED_ACHIEVEMENT_BADGE" })
        }
      )
    ),
    /* @__PURE__ */ React3.createElement(
      AnimatedTranslateWrapper,
      {
        isVisible,
        css: { animationFillMode: "forwards" },
        animationKey: preferredReducedMotion ? "reducedMotion" : "animated-subheader",
        flexDirection: "column",
        alignItems: "center"
      },
      /* @__PURE__ */ React3.createElement(
        UtilityText,
        {
          css: { color: "$onSurfaceTextSubdued", typography: "$bodyOne" }
        },
        formatMessage({ id: "YOUVE_COMPLETED" })
      ),
      /* @__PURE__ */ React3.createElement(
        HeadingText,
        {
          level: "2",
          size: "xl",
          css: {
            textAlign: "center"
          }
        },
        achievement == null ? void 0 : achievement.name
      )
    ),
    Boolean(achievement == null ? void 0 : achievement.reward.value) && /* @__PURE__ */ React3.createElement(
      AnimatedTranslateWrapper,
      {
        css: { animationFillMode: "forwards" },
        animationKey: "animated-points",
        flexDirection: "column",
        isVisible
      },
      /* @__PURE__ */ React3.createElement(
        StackLayout,
        {
          orientation: "vertical",
          horizontalAlignment: "center",
          css: { marginTop: "$oneAndHalf" }
        },
        /* @__PURE__ */ React3.createElement(
          UtilityText,
          {
            css: { typography: "$bodyTwoSecondary", marginBottom: "$half" }
          },
          formatMessage({ id: "YOUVE_EARNED_TOTAL" })
        ),
        /* @__PURE__ */ React3.createElement(Badge, { css: { backgroundColor: "$decorativeBrandSecondaryPastel" } }, unit === "league_points" /* LEAGUE_POINTS */ && /* @__PURE__ */ React3.createElement(PointsIcon, { value: value || 0 }), unit === "tokens" /* TOKENS */ && /* @__PURE__ */ React3.createElement(ChallengeTokenIcon, { value: value || 0 }), unit === "reward_points" /* REWARD_POINTS */ && /* @__PURE__ */ React3.createElement(
          RewardPointsIcon,
          {
            value: value || 0,
            pointsText: formatMessage({ id: "REWARD_POINTS" })
          }
        ))
      )
    )
  );
};

// src/components/celebration-modal/celebration-modal.view.tsx
var CelebrationModal = ({
  celebrations,
  onClose
}) => {
  const { formatMessage } = useIntl2();
  const [currentCarouselIndex, setCurrentCarouselIndex] = useState4(0);
  const [showAnimation, setShowAnimation] = useState4(false);
  const confettiAnimationRef = useRef2(null);
  useEffect6(() => {
    setTimeout(() => {
      setShowAnimation(true);
    }, 2100);
  }, []);
  useEffect6(() => {
    trackAnalyticsEvent(EVENT_NAME.SCREEN_LOADED, {
      product_area: "rewards" /* PRODUCT_AREA_REWARDS */,
      screen_name: "celebration modal" /* SCREEN_NAME_CELEBRATION_MODAL */,
      num_of_milestone_rewards: celebrations.length,
      has_points: celebrations.every(
        (celebration) => Boolean(celebration.reward.value)
      ),
      milestone_rewards_dict: AnalyticsDictFactory(
        celebrations.map((celebration) => ({
          milestone_reward_id: celebration.id,
          milestone_reward_name: celebration.name,
          has_points: Boolean(celebration.reward.value)
        }))
      )
    });
  }, [celebrations]);
  const handleButtonAction = (action, cta_title) => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      product_area: "rewards" /* PRODUCT_AREA_REWARDS */,
      screen_name: "celebration modal" /* SCREEN_NAME_CELEBRATION_MODAL */,
      detail: action,
      sub_detail: cta_title,
      num_of_milestone_rewards: celebrations.length,
      milestone_rewards_dict: AnalyticsDictFactory(
        celebrations.map((celebration) => ({
          milestone_reward_id: celebration.id,
          milestone_reward_name: celebration.name,
          has_points: Boolean(celebration.reward.value)
        }))
      ),
      milestone_rewards_index: currentCarouselIndex
    });
    onClose();
  };
  return /* @__PURE__ */ React4.createElement(
    Modal.Root,
    {
      defaultOpen: true,
      onOpenChange: (open) => {
        if (!open)
          handleButtonAction("close" /* CLOSE */);
      }
    },
    /* @__PURE__ */ React4.createElement(
      Modal.Content,
      {
        css: {
          ".GDS-modal": { width: "100%", maxWidth: "848px" }
        }
      },
      /* @__PURE__ */ React4.createElement(Modal.Title, null, /* @__PURE__ */ React4.createElement(VisuallyHidden, null, formatMessage({ id: "ACHIEVEMENT_EARNED" }))),
      /* @__PURE__ */ React4.createElement(
        StackLayout2,
        {
          orientation: "vertical",
          css: {
            position: "relative",
            backgroundColor: "transparent",
            alignItems: "center",
            justifyContent: "center",
            height: "100%"
          }
        },
        /* @__PURE__ */ React4.createElement(Box4, { css: { position: "absolute", top: 0, height: 300 } }, handleStaticAsset2(
          "ACHIEVEMENT_CONFETTI_ANIMATION" /* ACHIEVEMENT_CONFETTI_ANIMATION */,
          {
            isComponent: true,
            props: {
              animationRef: confettiAnimationRef,
              shouldPlay: showAnimation
            }
          }
        )),
        /* @__PURE__ */ React4.createElement(Box4, { css: { maxWidth: "384px", position: "relative" } }, /* @__PURE__ */ React4.createElement(
          Carousel,
          {
            sideArrows: true,
            showProgressDots: true,
            name: "celebration-modal",
            onIndexChange: (index) => setCurrentCarouselIndex(index)
          },
          celebrations.map((achievement, index) => /* @__PURE__ */ React4.createElement(
            CelebrationContent,
            {
              index,
              isVisible: index === currentCarouselIndex,
              achievement
            }
          ))
        )),
        /* @__PURE__ */ React4.createElement(
          StackLayout2,
          {
            spacing: "$oneAndHalf",
            horizontalAlignment: "center",
            orientation: "horizontal",
            css: {
              width: "100%",
              flexWrap: "wrap-reverse",
              marginTop: "$three"
            }
          },
          celebrations[currentCarouselIndex].secondary_cta_destination_url && /* @__PURE__ */ React4.createElement(Box4, null, /* @__PURE__ */ React4.createElement(
            Button,
            {
              priority: "secondary",
              as: Link,
              to: celebrations[currentCarouselIndex].secondary_cta_destination_url || "/#",
              quiet: true,
              onClick: () => handleButtonAction(
                "secondary cta" /* SECONDARY */,
                celebrations[currentCarouselIndex].secondary_cta_title
              )
            },
            celebrations[currentCarouselIndex].secondary_cta_title
          )),
          celebrations[currentCarouselIndex].primary_cta_destination_url && /* @__PURE__ */ React4.createElement(Box4, null, /* @__PURE__ */ React4.createElement(
            Button,
            {
              as: Link,
              to: celebrations[currentCarouselIndex].primary_cta_destination_url || "/#",
              priority: "primary",
              role: "link",
              onClick: () => handleButtonAction(
                "primary cta" /* PRIMARY */,
                celebrations[currentCarouselIndex].primary_cta_title
              ),
              css: { textDecoration: "none" }
            },
            celebrations[currentCarouselIndex].primary_cta_title
          ))
        )
      )
    )
  );
};

// src/components/progress-modal/progress-modal.view.tsx
import React6, { useEffect as useEffect7 } from "react";
import { LinkLegacy as RouterLink } from "@leagueplatform/routing";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";
import { EVENT_NAME as EVENT_NAME2, trackAnalyticsEvent as trackAnalyticsEvent2 } from "@leagueplatform/analytics";
import {
  Button as Button2,
  HeadingText as HeadingText3,
  Modal as Modal2,
  StackLayout as StackLayout4,
  VisuallyHidden as VisuallyHidden2
} from "@leagueplatform/genesis-core";

// src/components/badge-progress/badge-progress.view.tsx
import React5 from "react";
import { BadgeImage, ProgressBar } from "@leagueplatform/rewards-achievements";
import { HeadingText as HeadingText2, StackLayout as StackLayout3 } from "@leagueplatform/genesis-core";
var BadgeProgress = ({
  imageUrl,
  title,
  isLoading,
  currentActivity,
  totalActivities,
  progressTitle,
  completed
}) => /* @__PURE__ */ React5.createElement(
  StackLayout3,
  {
    className: "badge-progress-wrapper",
    orientation: "horizontal",
    verticalAlignment: "center",
    spacing: "$one",
    css: { width: "100%", padding: "$one" }
  },
  /* @__PURE__ */ React5.createElement(BadgeImage, { imageUrl, isDisabled: !completed }),
  /* @__PURE__ */ React5.createElement(StackLayout3, { horizontalAlignment: "stretch" }, /* @__PURE__ */ React5.createElement(HeadingText2, { level: "2", size: "xs" }, title), /* @__PURE__ */ React5.createElement(
    ProgressBar,
    {
      isLoading,
      currentActivity,
      totalActivities,
      progressTitle
    }
  ))
);

// src/components/progress-modal/progress-modal.view.tsx
var ProgressModal = ({
  onClose,
  activities,
  celebrations
}) => {
  const { formatMessage } = useIntl3();
  const handleButtonAction = (action) => {
    trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
      product_area: "rewards" /* PRODUCT_AREA_REWARDS */,
      screen_name: "progress modal" /* SCREEN_NAME_PROGRESS_MODAL */,
      detail: action
    });
    onClose();
  };
  useEffect7(() => {
    trackAnalyticsEvent2(EVENT_NAME2.SCREEN_LOADED, {
      product_area: "rewards" /* PRODUCT_AREA_REWARDS */,
      screen_name: "progress modal" /* SCREEN_NAME_PROGRESS_MODAL */,
      num_of_milestone_rewards: activities.length,
      milestone_rewards_dict: AnalyticsDictFactory(
        activities.map((activity) => ({
          milestone_reward_id: activity.id,
          milestone_reward_name: activity.name,
          completed: activity.progress.is_completed
        }))
      )
    });
  }, [activities]);
  return /* @__PURE__ */ React6.createElement(
    Modal2.Root,
    {
      defaultOpen: true,
      onOpenChange: (open) => {
        if (!open)
          handleButtonAction("close" /* CLOSE */);
      }
    },
    /* @__PURE__ */ React6.createElement(Modal2.Title, null, /* @__PURE__ */ React6.createElement(VisuallyHidden2, null, formatMessage({ id: "ACHIEVEMENT_PROGRESS" }))),
    /* @__PURE__ */ React6.createElement(
      Modal2.Content,
      {
        css: {
          ".GDS-modal": { width: "100%", maxWidth: "618px" }
        }
      },
      /* @__PURE__ */ React6.createElement(StackLayout4, { orientation: "vertical", horizontalAlignment: "center" }, /* @__PURE__ */ React6.createElement(HeadingText3, { level: "1", size: "xxl", css: { marginBottom: "$two" } }, formatMessage({ id: "KEEP_GOING" }), "!"), /* @__PURE__ */ React6.createElement(
        StackLayout4,
        {
          orientation: "vertical",
          horizontalAlignment: "center",
          css: { width: "100%", maxWidth: "350px", marginBottom: "$two" }
        },
        activities.map((activity) => /* @__PURE__ */ React6.createElement(
          BadgeProgress,
          {
            imageUrl: activity.image.large,
            isLoading: false,
            title: activity.name,
            totalActivities: activity.progress.threshold,
            currentActivity: activity.progress.current,
            progressTitle: `${activity.progress.current}/${activity.progress.threshold} ${formatMessage({ id: "ACTIVITIES" })}`,
            completed: activity.progress.is_completed
          }
        ))
      ), /* @__PURE__ */ React6.createElement(StackLayout4, { orientation: "horizontal", spacing: "$one" }, celebrations ? /* @__PURE__ */ React6.createElement(
        Button2,
        {
          onClick: () => handleButtonAction("continue" /* CONTINUE */)
        },
        formatMessage({ id: "CONTINUE" })
      ) : /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(
        Button2,
        {
          priority: "tertiary",
          quiet: true,
          role: "link",
          as: RouterLink,
          to: getModulePath(LEAGUE_MODULE_NAMES.rewardsAchievements),
          onClick: () => handleButtonAction("view all" /* VIEW_ALL */),
          css: {
            textDecoration: "none",
            marginInlineEnd: "$oneAndHalf"
          }
        },
        formatMessage({ id: "VIEW_ALL_ACHIEVEMENTS" })
      ), /* @__PURE__ */ React6.createElement(
        Button2,
        {
          onClick: () => handleButtonAction("take me back" /* TAKE_ME_BACK */)
        },
        formatMessage({ id: "TAKE_ME_BACK" })
      ))))
    )
  );
};

// src/components/rewards-toast-content/rewards-toast-content.view.tsx
import React10, { useEffect as useEffect8 } from "react";
import { EVENT_NAME as EVENT_NAME5, trackAnalyticsEvent as trackAnalyticsEvent5 } from "@leagueplatform/analytics";
import { Box as Box7, keyframes as keyframes3, styled as styled4 } from "@leagueplatform/genesis-core";

// src/components/toast-progress-banner/toast-progress-banner.view.tsx
import React8 from "react";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME4, trackAnalyticsEvent as trackAnalyticsEvent4 } from "@leagueplatform/analytics";

// src/components/close-button/close-button.view.tsx
import { EVENT_NAME as EVENT_NAME3, trackAnalyticsEvent as trackAnalyticsEvent3 } from "@leagueplatform/analytics";
import { Button as Button3 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import React7 from "react";
var CloseButton = ({
  onClose,
  activitiesLength
}) => {
  const { formatMessage } = useIntl4();
  function closeToast() {
    trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, {
      product_area: "rewards" /* PRODUCT_AREA_REWARDS */,
      screen_name: "progress toast" /* SCREEN_NAME_PROGRESS_TOAST */,
      detail: "dismissed" /* DISMISSED */,
      num_of_milestone_rewards: activitiesLength
    });
    onClose();
  }
  return /* @__PURE__ */ React7.createElement(
    Button3,
    {
      quiet: true,
      priority: "tertiary",
      icon: "tinyClose",
      onClick: () => closeToast(),
      css: { marginInlineStart: "$half", height: "$two" },
      size: "small",
      hideLabel: true
    },
    formatMessage({ id: "DISMISS_TOAST" })
  );
};

// src/components/toast-progress-banner/toast-progress-banner.view.tsx
import { Box as Box5, styled as styled2, TextAction } from "@leagueplatform/genesis-core";
var ToastButton = styled2(TextAction, {
  display: "inline-block",
  borderTopWidth: "$thin",
  borderTopStyle: "solid",
  borderTopColor: "$interactiveBorderDisabled",
  width: "100%",
  padding: "$half",
  textAlign: "center",
  "&:hover, &:active, &:focus": {
    backgroundColor: "$interactiveBackgroundHovered",
    color: "$interactiveActionHovered",
    textDecoration: "none"
  }
});
var AbsoluteWrapper = styled2(Box5, {
  position: "absolute",
  insetInlineEnd: "$quarter",
  top: "$quarter"
});
var BannerContainer = styled2(Box5, {
  position: "relative",
  backgroundColor: "$warningBackgroundSecondary",
  width: "330px",
  boxShadow: "$card"
});
var ToastProgressBanner = ({
  onlyProgress,
  activities,
  showMoreActivities,
  onClose
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const { formatMessage } = useIntl5();
  const handleSeeMoreAchievements = () => {
    trackAnalyticsEvent4(EVENT_NAME4.BUTTON_CLICKED, {
      product_area: "rewards" /* PRODUCT_AREA_REWARDS */,
      screen_name: "progress toast" /* SCREEN_NAME_PROGRESS_TOAST */,
      detail: "see more" /* SEE_MORE */,
      num_of_milestone_rewards: activities.length
    });
    showMoreActivities();
  };
  return /* @__PURE__ */ React8.createElement(
    BannerContainer,
    {
      css: {
        borderRadius: onlyProgress ? "$large" : "$none $none $large $large"
      }
    },
    /* @__PURE__ */ React8.createElement(
      BadgeProgress,
      {
        imageUrl: (_a = activities[0]) == null ? void 0 : _a.image.large,
        completed: (_b = activities[0]) == null ? void 0 : _b.progress.is_completed,
        title: (_c = activities[0]) == null ? void 0 : _c.name,
        isLoading: false,
        currentActivity: (_d = activities[0]) == null ? void 0 : _d.progress.current,
        totalActivities: (_e = activities[0]) == null ? void 0 : _e.progress.threshold,
        progressTitle: `${(_f = activities[0]) == null ? void 0 : _f.progress.current}/${(_g = activities[0]) == null ? void 0 : _g.progress.threshold} ${formatMessage({ id: "ACTIVITIES" })}`
      }
    ),
    activities.length > 1 && /* @__PURE__ */ React8.createElement(ToastButton, { onClick: handleSeeMoreAchievements }, formatMessage({ id: "SEE_ALL_ACHIEVEMENTS" })),
    onlyProgress && /* @__PURE__ */ React8.createElement(AbsoluteWrapper, null, /* @__PURE__ */ React8.createElement(CloseButton, { onClose, activitiesLength: activities.length }))
  );
};

// src/components/toast-points/toast-points.view.tsx
import React9 from "react";
import { usePrefersReducedMotion as usePrefersReducedMotion4 } from "@leagueplatform/web-common";
import {
  PointsIcon as PointsIcon2,
  ChallengeTokenIcon as ChallengeTokenIcon2,
  RewardPointsIcon as RewardPointsIcon2
} from "@leagueplatform/rewards-common";
import { Badge as Badge2 } from "@leagueplatform/web-common-components";
import {
  Box as Box6,
  UtilityText as UtilityText2,
  keyframes as keyframes2,
  styled as styled3
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
var slideBackAnimation = keyframes2({
  from: {
    transform: "translateX(calc(-50px * (1 - 2 * var(--league-is-rtl))))",
    opacity: 0
  },
  to: {
    transform: "translateX(0px)",
    opacity: 1
  }
});
var PointsWrapper = styled3(Box6, {
  display: "flex",
  height: "28px",
  animationTimingFunction: "ease-out",
  animationDuration: "0.45s",
  animationDelay: "0.45s",
  animationFillMode: "forwards",
  variants: {
    animationKey: {
      reduceMotion: {
        opacity: 1,
        animationName: "none"
      },
      slideBack: {
        opacity: 0,
        animationName: `${slideBackAnimation}`
      }
    }
  }
});
var ToastPoints = ({
  onlyPoints,
  title,
  points,
  onClose,
  activities,
  unit
}) => {
  const preferredReducedMotion = usePrefersReducedMotion4();
  const { formatMessage } = useIntl6();
  return /* @__PURE__ */ React9.createElement(
    Box6,
    {
      className: "toast-wrapper",
      css: {
        display: "flex",
        borderRadius: onlyPoints ? "$large" : "$large $large $none $none",
        backgroundColor: "$successBackgroundSubdued",
        width: "330px",
        minHeight: "48px",
        boxShadow: "$card",
        padding: "$half $one"
      }
    },
    /* @__PURE__ */ React9.createElement(
      Box6,
      {
        css: {
          display: "flex",
          gap: "$half",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          flexGrow: 1
        }
      },
      /* @__PURE__ */ React9.createElement(
        UtilityText2,
        {
          size: "sm",
          emphasis: "emphasized",
          css: { color: "$onSurfaceTextPrimary" }
        },
        title
      ),
      Boolean(points) && /* @__PURE__ */ React9.createElement(
        PointsWrapper,
        {
          animationKey: preferredReducedMotion ? "reduceMotion" : "slideBack",
          css: { animationFillMode: "forwards" }
        },
        /* @__PURE__ */ React9.createElement(Badge2, { css: { backgroundColor: "$successBackgroundSecondary" } }, unit === "league_points" /* LEAGUE_POINTS */ && /* @__PURE__ */ React9.createElement(PointsIcon2, { value: points }), unit === "tokens" /* TOKENS */ && /* @__PURE__ */ React9.createElement(ChallengeTokenIcon2, { value: points }), unit === "reward_points" /* REWARD_POINTS */ && /* @__PURE__ */ React9.createElement(
          RewardPointsIcon2,
          {
            value: points,
            pointsText: formatMessage({ id: "REWARD_POINTS" })
          }
        ))
      )
    ),
    /* @__PURE__ */ React9.createElement(CloseButton, { onClose, activitiesLength: activities.length })
  );
};

// src/components/rewards-toast-content/rewards-toast-content.view.tsx
var SlideUpAnimation = keyframes3({
  "0%": {
    transform: "translateY(500px)",
    opacity: 0
  },
  "70%": {
    transform: "translateY(-20px)",
    opacity: 1
  },
  "100%": {
    transform: "translateY(0)",
    opacity: 1
  }
});
var ToastContentWrapper = styled4(Box7, {
  animationName: `${SlideUpAnimation}`,
  animationDuration: "0.65s",
  animationTimingFunction: "ease-in-out"
});
var RewardsToastContent = ({
  pointsEarned,
  activities,
  showMoreActivities,
  closeToast
}) => {
  useEffect8(() => {
    trackAnalyticsEvent5(EVENT_NAME5.SCREEN_LOADED, {
      product_area: "rewards" /* PRODUCT_AREA_REWARDS */,
      screen_name: "progress toast" /* SCREEN_NAME_PROGRESS_TOAST */,
      action_rewarded: pointsEarned == null ? void 0 : pointsEarned.name,
      has_points: Boolean(pointsEarned),
      has_milestone_reward: Boolean(activities),
      num_of_milestone_rewards: (activities == null ? void 0 : activities.length) || 0,
      sub_detail: activities == null ? void 0 : activities[0].name,
      milestone_reward_id: activities == null ? void 0 : activities[0].id,
      has_see_more_button: activities ? activities.length > 1 : false
    });
  }, [activities, pointsEarned]);
  return /* @__PURE__ */ React10.createElement(
    ToastContentWrapper,
    {
      flexDirection: "column",
      css: { animationFillMode: "forwards" }
    },
    pointsEarned && /* @__PURE__ */ React10.createElement(
      ToastPoints,
      {
        onlyPoints: !activities,
        title: pointsEarned.name,
        points: pointsEarned.value,
        unit: pointsEarned.unit,
        activities: activities || [],
        onClose: closeToast
      }
    ),
    activities && /* @__PURE__ */ React10.createElement(
      ToastProgressBanner,
      {
        onClose: closeToast,
        onlyProgress: !pointsEarned,
        activities,
        showMoreActivities
      }
    )
  );
};

// src/components/rewards-event-controller/rewards-event-controller.view.tsx
var RewardsEventController = () => {
  const { currentRewardEvent, rewardEventViewed } = useDisplayRewardEvent();
  const {
    latest_reward: latestRewards,
    updated: inProgressMilestones,
    completed: completedMileStones
  } = (currentRewardEvent == null ? void 0 : currentRewardEvent.info.data) || {};
  const [showToast, setShowToast] = useState5(false);
  const [showProgressModal, setShowProgressModal] = useState5(false);
  const [showCelebrationModal, setShowCelebrationModal] = useState5(false);
  const [toastTimeout, setToastTimeout] = useState5();
  const closeToast = useCallback(
    (openProgressModal) => {
      if (toastTimeout) {
        clearTimeout(toastTimeout);
      }
      if (openProgressModal) {
        setShowToast(false);
        setShowProgressModal(true);
      } else if (completedMileStones) {
        setShowToast(false);
        setShowCelebrationModal(true);
      } else {
        setShowToast(false);
        rewardEventViewed();
      }
    },
    [completedMileStones, rewardEventViewed, toastTimeout]
  );
  const closeProgressModal = () => {
    setShowProgressModal(false);
    if (completedMileStones) {
      setShowCelebrationModal(true);
    } else {
      rewardEventViewed();
    }
  };
  const closeCelebrationModal = () => {
    setShowCelebrationModal(false);
    rewardEventViewed();
  };
  useEffect9(() => {
    if (currentRewardEvent) {
      if (inProgressMilestones || latestRewards) {
        setShowToast(true);
        setToastTimeout(
          setTimeout(() => {
            closeToast(false);
            trackAnalyticsEvent6(EVENT_NAME6.BUTTON_CLICKED, {
              product_area: "rewards" /* PRODUCT_AREA_REWARDS */,
              screen_name: "progress toast" /* SCREEN_NAME_PROGRESS_TOAST */,
              detail: "auto_dismissed" /* AUTO_DISMISSED */,
              num_of_milestone_rewards: (inProgressMilestones == null ? void 0 : inProgressMilestones.length) || 0
            });
          }, 10450)
        );
      } else if (completedMileStones) {
        setShowCelebrationModal(true);
      }
    }
  }, [
    currentRewardEvent,
    completedMileStones,
    inProgressMilestones,
    latestRewards
  ]);
  return /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(
    Box8,
    {
      "aria-live": "polite",
      css: {
        position: "fixed",
        bottom: "$twoAndHalf",
        insetInlineEnd: "$four",
        zIndex: 1e4
      }
    },
    showToast && /* @__PURE__ */ React11.createElement(
      RewardsToastContent,
      {
        pointsEarned: latestRewards,
        activities: inProgressMilestones,
        showMoreActivities: () => {
          closeToast(true);
        },
        closeToast: () => closeToast(false)
      }
    )
  ), showProgressModal && inProgressMilestones && /* @__PURE__ */ React11.createElement(
    ProgressModal,
    {
      celebrations: completedMileStones,
      activities: inProgressMilestones,
      onClose: closeProgressModal
    }
  ), showCelebrationModal && completedMileStones && /* @__PURE__ */ React11.createElement(
    CelebrationModal,
    {
      celebrations: completedMileStones,
      onClose: closeCelebrationModal
    }
  ));
};

// src/constants/feature-flag-names.constants.ts
var REWARDS_EVENTS_UPDATES = "rewards_events_updates";

// src/index.ts
initModule();
export {
  REWARDS_EVENTS_UPDATES,
  RewardsEventController
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/rewards-events'] = window.leagueSDKsPresent['@leagueplatform/rewards-events'] || [];
    window.leagueSDKsPresent['@leagueplatform/rewards-events'].push('2.27.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/rewards-events'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/rewards-events module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map